$(function () {
    var b = window.patientInformation.bookmark;

    $("[data-bookmark]").click(function () {
        b.toggleBookmark(this);
        return false;
    });
});